import Flex from 'shared/ui/Flex'
import { Skeleton } from 'shared/ui/Skeleton'

export const CoverPageSkeleton = () => {
  return (
    <Flex direction="column" width="100%">
      <Skeleton
        width="100%"
        height="100%"
        colorLevel={2}
        radius={8}
        animate={true}
      />
      <Skeleton
        width={80}
        height={12}
        colorLevel={3}
        radius={9999}
        marginTop={24}
        style={{ margin: '24px auto 0' }}
      />
    </Flex>
  )
}
